/* ════════════ THE FINE PRINT ════════════
   The corps page's atmosphere: terms and conditions drizzle down
   the screen in unreadable grey, except for the occasional line
   they actually mean, which surfaces in acid lime. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function fineprint(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#fineprint")!;
  const ctx = c.getContext("2d")!;

  const BOILERPLATE = [
    "the parties hereto agree", "without limitation", "in perpetuity",
    "successors and assigns", "at our sole discretion", "may share with partners",
    "as permitted by law", "subject to change", "herein referred to as",
    "irrevocable, worldwide", "section 4.2(b)(iii)", "non-exclusive license",
  ];
  const THE_POINT = [
    "ACCEPT ALL", "I AGREE", "we value your privacy", "personalized ads",
    "trusted partners (1,482)", "retention: forever",
  ];
  const LIME = "#c6ff4d";
  const GREY = "#9aa0a6";

  type Line = {
    x: number;
    y: number;
    v: number; // fall speed
    size: number;
    col: string;
    text: string;
    a: number; // base alpha
  };
  let lines: Line[] = [];

  const spawn = (first: boolean): Line => {
    const isPoint = Math.random() < 0.12;
    const pool = isPoint ? THE_POINT : BOILERPLATE;
    return {
      x: Math.random() * c.width,
      y: first ? Math.random() * c.height : -14,
      v: 0.1 + Math.random() * 0.25,
      size: isPoint ? 12 + Math.random() * 5 : 9 + Math.random() * 3,
      col: isPoint ? LIME : GREY,
      text: pool[(Math.random() * pool.length) | 0]!,
      a: isPoint ? 0.45 : 0.16,
    };
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(44, Math.floor((c.width * c.height) / 42000));
    lines = Array.from({ length: count }, () => spawn(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const l of lines) {
      // fade near top and bottom edges so lines don't pop in and out
      const edge = Math.min(l.y / 80, (c.height - l.y) / 80, 1);
      ctx.globalAlpha = Math.max(0, edge) * l.a;
      ctx.fillStyle = l.col;
      ctx.font = `${l.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(l.text, l.x, l.y);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (let i = 0; i < lines.length; i++) {
      const l = lines[i]!;
      l.y += l.v; // settling downward, like everything in the terms
      if (l.y > c.height + 14) lines[i] = spawn(false);
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(fineprint);
